import { useSyncExternalStore } from 'react';

import { breakpoint } from '../uikit/theme/theme';

const listFiltersCollapseMediaQuery = `(max-width: ${breakpoint.listFiltersCollapse}px)`;

function getListFiltersCollapseMatch(): MediaQueryList | null {
  if (typeof window === 'undefined') {
    return null;
  }
  if (typeof window.matchMedia !== 'function') {
    return null;
  }
  return window.matchMedia(listFiltersCollapseMediaQuery);
}

/**
 * true, когда панель фильтров списка должна быть свёрнута в кнопку «Фильтры»
 * (viewport ≤ theme.breakpoint.listFiltersCollapse). Шире, чем theme.device.mobile,
 * чтобы учитывать телефоны в альбомной ориентации и узкие окна браузера.
 */
export function useListFiltersCollapsibleViewport(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = getListFiltersCollapseMatch();
      if (!mq) {
        return () => {};
      }
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => getListFiltersCollapseMatch()?.matches ?? false,
    () => false,
  );
}
